export default {"src":"/trader-new/_next/static/media/help_icon.445173dc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};